var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pre", [_vm._v(_vm._s(_vm.lobbyId))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-controls__group",
          class: { "c-controls__group--mb": !_vm.lobby.ID }
        },
        [
          _c("label", { staticClass: "c-controls__label" }, [
            _vm._v("Scenario")
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.scenario,
                    expression: "scenario"
                  }
                ],
                attrs: { disabled: !!_vm.lobbyId },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.scenario = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.changeScenario
                  ]
                }
              },
              _vm._l(_vm.slide.settings.scenarios, function(name, scenarioId) {
                return _c(
                  "option",
                  { key: scenarioId, domProps: { value: scenarioId } },
                  [_vm._v(_vm._s(name))]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button c-controls__button",
              attrs: { disabled: !!_vm.lobbyId || !_vm.scenario },
              on: {
                click: function($event) {
                  return _vm.create()
                }
              }
            },
            [
              _vm.lobbyId
                ? [_vm._v("Lobby is geopend")]
                : [_vm._v("Open de lobby")]
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.lobby.ID
        ? [
            _c("hr", { staticClass: "c-controls__rule" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-controls__group c-controls__group--mb" },
              [
                _c("div", { staticClass: "c-controls__text" }, [
                  _vm._v(
                    "(" +
                      _vm._s(_vm.lobby.Players) +
                      " van de " +
                      _vm._s(_vm.students.length) +
                      " studenten zitten in de lobby)"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button c-controls__button",
                    attrs: { disabled: _vm.running },
                    on: {
                      click: function($event) {
                        return _vm.start()
                      }
                    }
                  },
                  [_vm._v("\n\t\t\t\tStart de lobby\n\t\t\t")]
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }